// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hIp7","delete":"styles_delete__2r66G","update":"styles_update__3MZbm","add":"styles_add__2p1HL"};